import React, { useEffect, useState } from "react";
import { KTSVG } from "../../../helpers";
import { db, authFirebase } from "../../../../config/firebase";
import { doc, collection, getDocs, getDoc, addDoc } from "firebase/firestore";

type Props = {
  className: string;
  innerPadding?: string;
};

const StepContent1: React.FC<Props> = ({ className, innerPadding = ""}) => {

  const [data, setData] = useState({
    title: "",
    section1: { title: "", body: "" },
    section2: { title: "", body: "" },
    section3: { title: "", body: "" },
    section4: { title: "", body: "" },
    section5: { title: "", body: "" },
    section6: { title: "", body: "" },
  });

  const fetchData = async () => {

    // This gets all content in the collection
    const querySnapshot = await getDocs(collection(db, "content"));
  
    return querySnapshot;
  }

  useEffect(() => {
    fetchData()
    .then(querySnapshot => {
      const docs = querySnapshot.docs.map(doc => doc.data());
      const firstDoc = docs[0];
      if (firstDoc) {
        setData({
          title: firstDoc.title || "",
          section1: {
            title: firstDoc.section1?.title || "",
            body: firstDoc.section1?.body || ""
          },
          section2: {
            title: firstDoc.section2?.title || "",
            body: firstDoc.section2?.body || ""
          },
          section3: {
            title: firstDoc.section3?.title || "",
            body: firstDoc.section3?.body || ""
          },
          section4: {
            title: firstDoc.section4?.title || "",
            body: firstDoc.section4?.body || ""
          },
          section5: {
            title: firstDoc.section5?.title || "",
            body: firstDoc.section5?.body || ""
          },
          section6: {
            title: firstDoc.section6?.title || "",
            body: firstDoc.section6?.body || ""
          }
        });
      }
    });
  }, []);
    
  return (

    <div className={`card ${className}`}>
      {/* begin::Body */}
      <div className={`card-body ${innerPadding}`}>
        {/* begin::Title */}
        <div className="mb-10">
          <h3 className="fw-bold text-dark mb-2 fs-3">{data ? data.title : <p>Loading data...</p>}</h3>
          <span className="text-muted fs-7">
            Read each section and then fill in your answers in the workbook.
          </span>
        </div>
        {/* end::Title */}

        {/* begin::Section */}
        <div className="mb-10">
          <div className="accordion" id="kt_accordion_1">
            <div className="accordion-item">
              <p className="accordion-header" id="kt_accordion_1_header_1">
                <button
                  className="accordion-button fs-7 fw-bold"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#kt_accordion_1_body_1"
                  aria-expanded="true"
                  aria-controls="kt_accordion_1_body_1"
                >
                  {data ? data.section1.title : <p>Loading data...</p>}
                </button>
              </p>
              <div
                id="kt_accordion_1_body_1"
                className="accordion-collapse collapse show"
                aria-labelledby="kt_accordion_1_header_1"
                data-bs-parent="#kt_accordion_1"
              >
                <div className="accordion-body">
                  {/* {data ? data.section1.body : <p>Loading data...</p>} */}
                  <p className="fs-7">The single necessary and sufficient condition for a business is a paying customer. The process starts not by focusing on the idea, but on who will be the end user. Therefore, you will focus on the customer and build the company from the endpoint, rather than trying to push out on the customer what we think they need.</p>

                  <p className="fs-7">This is the first in a series of steps which will help you define, test and understand who your customer is. In this first step, two things are critical:</p>

                  <ol>
                    <li>
                      <strong className="fs-7">See the world through the eyes of your customer</strong>
                      <p className="fs-7">Just because you want something, doesn't mean everybody else does or that they want it in the same way. What you want is not important. Did you start your company with the solution as the center of it—with customers rotating around it? Invert that. See the customer as the hub and the solution rotating around them.</p>
                    </li>
                    <li>
                      <strong className="fs-7">Open up your mind</strong>
                      <p className="fs-7">Brainstorm all potential customers. Who can use your idea or technology? Let a thousand flowers bloom at this point—and stop and smell every one of them!</p>
                    </li>
                  </ol>

                  <p className="fs-7"><strong>Be careful:</strong> Make distinct market segments that are not so broad as to be meaningless. For instance:</p>

                  <ul className="fs-7">
                    <li><em>Market segment: consumers</em>, tells you absolutely nothing.</li>
                    <li><em>Market segment: 24–30 year old male, who is online and makes over $75K per year, lives in urban environment</em>, tells you something very specific about your customer.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="kt_accordion_1_header_2">
                <button
                  className="accordion-button fs-7 fw-bold collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#kt_accordion_1_body_2"
                  aria-expanded="false"
                  aria-controls="kt_accordion_1_body_2"
                >
                {data ? data.section2.title : <p>Loading data...</p>}
                </button>
              </h2>
              <div
                id="kt_accordion_1_body_2"
                className="accordion-collapse collapse"
                aria-labelledby="kt_accordion_1_header_2"
                data-bs-parent="#kt_accordion_1"
              >
                <div className="accordion-body">
                  {data ? data.section2.body : <p>Loading data...</p>}
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="kt_accordion_1_header_3">
                <button
                  className="accordion-button fs-7 fw-bold collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#kt_accordion_1_body_3"
                  aria-expanded="false"
                  aria-controls="kt_accordion_1_body_3"
                >
                  {data ? data.section3.title : <p>Loading data...</p>}
                </button>
              </h2>
              <div
                id="kt_accordion_1_body_3"
                className="accordion-collapse collapse"
                aria-labelledby="kt_accordion_1_header_3"
                data-bs-parent="#kt_accordion_1"
              >
                <div className="accordion-body">
                {data ? data.section3.body : <p>Loading data...</p>}
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="kt_accordion_1_header_4">
                <button
                  className="accordion-button fs-7 fw-bold collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#kt_accordion_1_body_4"
                  aria-expanded="false"
                  aria-controls="kt_accordion_1_body_4"
                >
                  {data ? data.section4.title : <p>Loading data...</p>}
                </button>
              </h2>
              <div
                id="kt_accordion_1_body_4"
                className="accordion-collapse collapse"
                aria-labelledby="kt_accordion_1_header_4"
                data-bs-parent="#kt_accordion_1"
              >
                <div className="accordion-body">
                {data ? data.section4.body : <p>Loading data...</p>}                
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="kt_accordion_1_header_5">
                <button
                  className="accordion-button fs-7 fw-bold collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#kt_accordion_1_body_5"
                  aria-expanded="false"
                  aria-controls="kt_accordion_1_body_5"
                >
                  {data ? data.section5.title : <p>Loading data...</p>}
                </button>
              </h2>
              <div
                id="kt_accordion_1_body_5"
                className="accordion-collapse collapse"
                aria-labelledby="kt_accordion_1_header_5"
                data-bs-parent="#kt_accordion_1"
              >
                <div className="accordion-body">
                {data ? data.section5.body : <p>Loading data...</p>}                  
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="kt_accordion_1_header_6">
                <button
                  className="accordion-button fs-7 fw-bold collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#kt_accordion_1_body_6"
                  aria-expanded="false"
                  aria-controls="kt_accordion_1_body_6"
                >
                  {data ? data.section6.title : <p>Loading data...</p>}
                </button>
              </h2>
              <div
                id="kt_accordion_1_body_6"
                className="accordion-collapse collapse"
                aria-labelledby="kt_accordion_1_header_6"
                data-bs-parent="#kt_accordion_1"
              >
                <div className="accordion-body">
                {data ? data.section6.body : <p>Loading data...</p>}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end::Section */}

      </div>
      {/* end: Card Body */}
    </div>
  );
};

export { StepContent1 };
